// actions
const FINSIHED_FETCHING_ECONOMIC_ASSET_LIST_SETTING = 'FINSIHED_FETCHING_ECONOMIC_ASSET_LIST_SETTING'
const ERROR_FETCHING_ECONOMIC_ASSET_LIST_SETTING = 'ERROR_FETCHING_ECONOMIC_ASSET_LIST_SETTING'
const SHOW_ECONOMIC_ASSETS_LOADER = 'SHOW_ECONOMIC_ASSETS_LOADER'
const HIDE_ECONOMIC_ASSETS_LOADER = 'HIDE_ECONOMIC_ASSETS_LOADER'
const SET_ECONOMIC_ASSET_LIST_ITEMS = 'SET_ECONOMIC_ASSET_LIST_ITEMS'
const SET_ECONOMIC_ASSET_PAGINATION = 'SET_ECONOMIC_ASSET_PAGINATION'
const SET_ECONOMIC_ASSET_SEARCH_TERM = 'SET_ECONOMIC_ASSET_SEARCH_TERM'
const REFRESH_ECONOMIC_ASSETS = 'REFRESH_ECONOMIC_ASSETS'
const STOP_REFRESHING_ECONOMIC_ASSETS = 'STOP_REFRESHING'
const OPEN_EDIT_DRAWER = 'OPEN_EDIT_DRAWER'
const CLOSE_EDIT_DRAWER = 'CLOSE_EDIT_DRAWER'
const SET_ECONOMIC_ASSET_ID = 'SET_ECONOMIC_ASSET_ID'
const SET_ECONOMIC_ASSET_ID_NULL = 'SET_ECONOMIC_ASSET_ID_NULL'

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    columns: [],
  },
  searchTerm: '',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered articles
    totalCount: 0, // count of all articles
    limit: 20, // max articles on page
  },
  shouldRefresh: false,
  editDrawerOpen: false,
  assetId: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINSIHED_FETCHING_ECONOMIC_ASSET_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case SHOW_ECONOMIC_ASSETS_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_ECONOMIC_ASSETS_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_ECONOMIC_ASSET_LIST_ITEMS:
      const { articles } = action
      return Object.assign({}, state, {
        items: articles,
      })

    case SET_ECONOMIC_ASSET_ID:
      const { id } = action
      return Object.assign({}, state, {
        assetId: id,
      })

    case SET_ECONOMIC_ASSET_ID_NULL:
      return Object.assign({}, state, {
        assetId: null,
      })

    case SET_ECONOMIC_ASSET_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return Object.assign({}, state, { pagination: updatedPagination })

    case SET_ECONOMIC_ASSET_SEARCH_TERM:
      const { searchTerm } = action
      return Object.assign({}, state, {
        searchTerm,
      })

    case REFRESH_ECONOMIC_ASSETS:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING_ECONOMIC_ASSETS:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_ECONOMIC_ASSET_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    case OPEN_EDIT_DRAWER:
      return Object.assign({}, state, {
        editDrawerOpen: true,
      })

    case CLOSE_EDIT_DRAWER:
      return Object.assign({}, state, {
        editDrawerOpen: false,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_ECONOMIC_ASSETS_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_ECONOMIC_ASSETS_LOADER,
  }
}

export const setListItems = (articles) => {
  return {
    type: SET_ECONOMIC_ASSET_LIST_ITEMS,
    articles,
  }
}

export const storeEconomicAssetId = (id) => {
  return {
    type: SET_ECONOMIC_ASSET_ID,
    id,
  }
}
export const setEconomicAssetIdNull = () => {
  return {
    type: SET_ECONOMIC_ASSET_ID_NULL,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH_ECONOMIC_ASSETS,
  }
}

export const stopRefreshingList = () => {
  return {
    type: STOP_REFRESHING_ECONOMIC_ASSETS,
  }
}

export const setPagination = (pagination) => {
  return {
    type: SET_ECONOMIC_ASSET_PAGINATION,
    pagination,
  }
}

export const setSearchTerm = (searchTerm) => {
  return {
    type: SET_ECONOMIC_ASSET_SEARCH_TERM,
    searchTerm,
  }
}

export const openEditDrawer = () => ({
  type: OPEN_EDIT_DRAWER,
})

export const closeEditDrawer = () => ({
  type: CLOSE_EDIT_DRAWER,
})
